import type { IAbTest } from 'ts/interfaces/abTest/abTest';

export const formatAbTestsForAnalytics = (abTests: IAbTest[]): string[] => {
  return abTests
    ?.filter((test) => test.variant !== false && test.variant !== 'false')
    .map((test) => `${test.feature}_${test.variant}`);
};
